import { create } from "zustand";
import { DashboardState } from "../types/api";

import { getDashboard } from "../api/dashboardApi";
import { devtools } from "zustand/middleware";

const useDashboardStore = create<DashboardState>()(
  devtools(
    (set) => ({
      dashboard: null,
      loading: false,
      error: null,

      fetchDashboard: async (token: string) => {
        set({ loading: true, error: null });
        try {
          const response = await getDashboard(token);
          if (!response) {
            throw new Error("Failed to fetch courses");
          }

          set({ dashboard: response.data, loading: false });
        } catch (error: any) {
          set({ error: error.message, loading: false });
        }
      },
      resetDashboardState: () => {
        set({
          dashboard: null,
        });
      },
    }),
    { name: "dashboardStore" }
  )
);

export default useDashboardStore;
